<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section  v-for="assistant in listeAssistantMaternel" :key="assistant.id">
                        <div class="Fiche" v-if="assistant.production_locales == true">
                            <div class="Infos Contact">
                                <table class="Tableau-Fiche Contact">
                                    <tbody>
                                        <tr>
                                            <th colspan="2" class="colspandeux"><h6>{{assistant.prenom}} {{assistant.nom}}</h6></th>
                                        </tr>
                                        <tr>
                                            <th>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" class="logo-type-contact fill">
                                                    <path id="Icon_material-place" data-name="Icon material-place" d="M18,3A10.492,10.492,0,0,0,7.5,13.5C7.5,21.375,18,33,18,33S28.5,21.375,28.5,13.5A10.492,10.492,0,0,0,18,3Zm0,14.25a3.75,3.75,0,1,1,3.75-3.75A3.751,3.751,0,0,1,18,17.25Z" transform="translate(-7.5 -3)"/>
                                                </svg>
                                            </th>
                                            <th>
                                                <a :href="assistant.lien_adresse">{{assistant.adresse}}</a>
                                            </th>
                                        </tr>
                                        <tr v-if="assistant.tel != ''">
                                            <th>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" class="logo-type-contact fill">
                                                    <path id="Icon_awesome-phone-alt" data-name="Icon awesome-phone-alt" d="M29.144,21.2l-6.563-2.813a1.406,1.406,0,0,0-1.641.4l-2.906,3.551A21.719,21.719,0,0,1,7.652,11.96L11.2,9.054a1.4,1.4,0,0,0,.4-1.641L8.8.85A1.416,1.416,0,0,0,7.184.036L1.09,1.442A1.406,1.406,0,0,0,0,2.813,27.185,27.185,0,0,0,27.188,30a1.406,1.406,0,0,0,1.371-1.09l1.406-6.094a1.423,1.423,0,0,0-.821-1.617Z" transform="translate(0 0)"/>
                                                </svg>
                                            </th>
                                            <th>
                                                <a :href="'tel:'+assistant.tel" >{{assistant.tel}}</a>
                                            </th>
                                        </tr>
                                        <tr v-if="assistant.email != ''">
                                            <th>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="34.178" height="27" viewBox="0 0 34.178 27" class="logo-type-contact stroke">
                                                    <g id="Icon_feather-mail" data-name="Icon feather-mail" transform="translate(-0.911 -4.5)">
                                                    <path id="Tracé_2" data-name="Tracé 2" d="M6,6H30a3.009,3.009,0,0,1,3,3V27a3.009,3.009,0,0,1-3,3H6a3.009,3.009,0,0,1-3-3V9A3.009,3.009,0,0,1,6,6Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                    <path id="Tracé_3" data-name="Tracé 3" d="M33,9,18,19.5,3,9" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                    </g>
                                                </svg>
                                            </th>
                                            <th>
                                                <a :href="'mailto:'+assistant.email" >{{assistant.email}}</a>
                                            </th>
                                        </tr>

                                        <tr>
                                            <th>
                                                <b>Domaine<b v-if="assistant.domaine.length > 1">s</b></b>
                                            </th>
                                            <th>
                                                <b v-for="domaine in assistant.domaine" :key="domaine.term_id">{{domaine.name}}<br></b>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <iframe class="contenu-droit-page" :src="assistant.lien_adresse_iframe" v-if="assistant.lien_adresse_iframe != null" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'AssistantMaternel',
    data () {
        return{
            listeAssistantMaternel:{
                id:0,
                prenom:null,
                nom:null,
                adresse: null,
                lien_adresse: null,
                email: null,
                tel: null,
                places_disponibles: null,
                type: null,
                domaine: {
                    term_id: 0,
                    name: null
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'am-artisan-entreprise/v1/listeAM-artisans-entreprises')
        .then(response =>{
        this.listeAssistantMaternel = response.data;
            console.log('listeAssistantMaternel', this.listeAssistantMaternel)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Productions locales'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/ProdLocales.vue